import { z } from 'zod';
import { EmploymentScheduleType } from '../types/EmploymentScheduleType';
import { clockTimePattern } from '../utils/regex';

const dayTimes = [
  ['startTime', 'Fyll i starttid som HH:MM'],
  ['endTime', 'Fyll i sluttid som HH:MM'],
  ['workedHours', 'Fyll i arbetstimmar som HH:MM'],
] as const;

const scheduleDay = z
  .object({
    day: z.string().optional(),
    startTime: z.string().optional(),
    endTime: z.string().optional(),
    workedHours: z.string().optional(),
  })
  .nullable();

// A ticked day has a day name. The backend refuses it without its times as HH:mm, and an
// hourly schedule holds no worked hours.
export const employmentSchedulePageSchema = z
  .object({
    name: z.string().nonempty('Obligatoriskt fält'),
    employmentScheduleType: z.nativeEnum(EmploymentScheduleType),
    employmentSchedule: z.array(scheduleDay).optional(),
  })
  .superRefine(({ employmentScheduleType, employmentSchedule }, ctx) => {
    employmentSchedule?.forEach((day, index) => {
      if (!day?.day) {
        return;
      }
      for (const [field, message] of dayTimes) {
        const skipped =
          field === 'workedHours' && employmentScheduleType === EmploymentScheduleType.Hourly;
        if (!skipped && !clockTimePattern.test(day[field] ?? '')) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message,
            path: ['employmentSchedule', index, field],
          });
        }
      }
    });
  });
